import { render } from "./DriverInfo.vue?vue&type=template&id=fed56748&scoped=true"
import script from "./DriverInfo.vue?vue&type=script&lang=js"
export * from "./DriverInfo.vue?vue&type=script&lang=js"

import "./DriverInfo.vue?vue&type=style&index=0&id=fed56748&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed56748"]])

export default __exports__